<template>
  <el-row justify="center">
    <el-col :xs="24" :sm="20" :md="16" :lg="12">

      <el-card shadow="never">
        <template #header>
          <div class="card-header">
            <h5 class="mb-0">提交积分申请</h5>
          </div>
        </template>

        <el-alert
          v-if="successMessage"
          :title="successMessage"
          type="success"
          show-icon
          class="mb-3"
          :closable="false"
        />
        <el-alert
          v-if="errorMessage"
          :title="errorMessage"
          type="error"
          show-icon
          class="mb-3"
          :closable="false"
        />

        <el-form
          :model="formData"
          :rules="formRules"
          ref="applyFormRef"
          label-position="top"
          @submit.prevent="handleSubmit"
        >
          <el-form-item label="申请规则" prop="rule">
            <el-select
              v-model="formData.rule"
              placeholder="-- 请选择一个积分规则 --"
              class="w-100"
              size="large"
              filterable
              :loading="isPageLoading"
            >
              <el-option
                v-for="rule in rules"
                :key="rule.id"
                :label="rule.description"
                :value="rule.id"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="申请详情/说明" prop="details">
            <el-input
              v-model="formData.details"
              type="textarea"
              :rows="5"
              placeholder="请详细说明您申请积分的事由..."
            />
          </el-form-item>

          <el-form-item label="证明材料 (可选)" prop="proof">
            <el-upload
              ref="uploadRef"
              action="#"
              :auto-upload="false"
              :limit="1"
              :on-exceed="handleFileExceed"
              :on-change="handleFileChange"
              class="w-100"
            >
              <el-button type="default">
                <i class="fas fa-upload me-2"></i> 点击选择文件
              </el-button>
              <template #tip>
                <div class="el-upload__tip">
                  请上传图片、PDF 或文档 (如有需要)。
                </div>
              </template>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="large"
              @click="handleSubmit"
              :loading="isLoading"
              class="w-100"
            >
              {{ isLoading ? '正在提交...' : '提交申请' }}
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>

    </el-col>
  </el-row>
</template>

<script>
import axios from 'axios';
// 【V4.0 新增】导入 Element Plus 消息提示
import { ElMessage } from 'element-plus';

export default {
  name: 'ApplyView',
  data() {
    return {
      // 1. 状态
      rules: [],
      isPageLoading: true,
      isLoading: false,

      // 2. 表单数据
      formData: {
        rule: null,
        details: '',
      },

      // 3. 专门存放用户选择的文件
      selectedFile: null,

      // 4. 提示信息 (我们现在改用 ElMessage)
      successMessage: null, // (保留, 用于成功后的提示)
      errorMessage: null,   // (保留, 用于服务器错误)

      // 5. 【V4.0】 Element Plus 表单验证规则
      formRules: {
        rule: [
          { required: true, message: '您必须选择一个申请规则。', trigger: 'change' },
        ],
        details: [
          { required: true, message: '申请详情不能为空。', trigger: 'blur' },
        ],
        // (proof 是可选的, 无需规则)
      }
    };
  },

  // mounted() 钩子 (已重构)
  async mounted() {
    this.isPageLoading = true;
    const token = localStorage.getItem('authToken');
    if (!token) {
      this.$router.push('/login');
      return;
    }

    try {
      // (保持不变)
      const response = await axios.get('/members/api/rules/', {
        headers: { 'Authorization': `Token ${token}` }
      });
      // (保持不变, 我们已在 views.py 修复了分页)
      this.rules = response.data;

    } catch (error) {
      console.error('获取规则列表失败:', error);
      localStorage.removeItem('authToken');
      this.$router.push('/login');
    } finally {
      this.isPageLoading = false;
    }
  },

  methods: {

    // --- 【V4.0 方法】 (el-upload) ---
    handleFileChange(file, fileList) {
      // 当文件列表变化时 (添加或移除)
      if (fileList.length > 0) {
        this.selectedFile = file.raw; // 'file.raw' 才是真正的文件对象
      } else {
        this.selectedFile = null;
      }
    },
    handleFileExceed(files) {
      // 当尝试添加超过 limit (1) 个文件时
      // 先清除旧文件, 再添加新文件
      this.$refs.uploadRef.clearFiles();
      this.$refs.uploadRef.handleStart(files[0]);
      this.selectedFile = files[0];
    },
    // ---------------------------------

    /**
     * handleSubmit() (已【重构】为使用 el-form 验证)
     */
    async handleSubmit() {
      // 1. 【V4.0】使用 el-form 的 'validate' 方法
      this.$refs.applyFormRef.validate(async (valid) => {
        if (!valid) {
          // 如果 el-form 验证失败, 停止
          ElMessage({ type: 'error', message: '请检查您的表单是否填写完整。' });
          return false;
        }

        // --- 验证通过, 开始提交 ---
        this.isLoading = true;
        this.successMessage = null;
        this.errorMessage = null;

        const token = localStorage.getItem('authToken');

        // 2. (保持不变) 创建 FormData
        const formData = new FormData();
        formData.append('rule', this.formData.rule);
        formData.append('details', this.formData.details);

        // 3. (保持不变) 添加文件
        if (this.selectedFile) {
          formData.append('proof', this.selectedFile, this.selectedFile.name);
        }

        try {
          // 4. 【POST】请求 (保持不变)
          await axios.post('/members/api/apply/', formData, {
            headers: {
              'Authorization': `Token ${token}`
            }
          });

          // 5. 处理成功
          this.successMessage = '您的申请已成功提交！2秒后将返回主页。';
          // 重置表单
          this.$refs.applyFormRef.resetFields();
          this.$refs.uploadRef.clearFiles(); // 清空 el-upload 的文件列表
          this.selectedFile = null;

          setTimeout(() => {
            this.$router.push('/dashboard'); // (跳转到个人中心)
          }, 2000);

        } catch (error) {
          // 6. 处理失败
          console.error('提交申请失败:', error);
          if (error.response && error.response.data) {
             if (error.response.data.proof) {
                this.errorMessage = `文件上传失败: ${error.response.data.proof.join(' ')}`;
             } else {
                this.errorMessage = '提交失败，请检查您的填写内容或稍后再试。';
             }
          } else {
             this.errorMessage = '提交失败，发生未知错误。';
          }
        } finally {
          // 7. 结束“提交”状态
          this.isLoading = false;
        }
        // --- 提交结束 ---
      });
    }
  }
};
</script>

<style scoped>
/* --- V4.0 样式 --- */
.w-100 {
  width: 100%;
}
.card-header h5 {
  font-weight: 600;
  margin-bottom: 0;
}
.el-upload__tip {
  font-size: 0.85rem;
  color: var(--el-text-color-secondary);
}
.mb-3 {
  margin-bottom: 1.25rem; /* (el-alert 没有默认 mb) */
}
/* 确保 el-upload 按钮占满宽度 */
.el-upload {
  width: 100%;
}
:deep(.el-upload-dragger) {
  width: 100% !important;
}
</style>